export default "__VITE_ASSET__0CJv24GJ__"